export default "/apps/maps/img/routing-icon.png";